<template>
  <div v-if="related.length" id="relatedRoot">
    <div id="title">
      <span>Related</span>
    </div>
    <div id="relatedContent">
      <div v-for="(item, index) in related" :key="index" @click="showSnackBar(item.link)" :href="item.link"
           id="card">
        <div id="sourceInfo">
          <img id="icon" :src="item.logo"/>
          <span id="source" v-html="item.title"></span>
        </div>
        <div id="linkTitle">
          <h2 v-html="item.text"></h2>
        </div>
      </div>
    </div>
    <!-- Snackbar -->
    <div class="mdc-snackbar" :class="{'mdc-snackbar--open': snackBarVisibility}">
      <div class="mdc-snackbar__surface">
        <div class="mdc-snackbar__label" role="status" aria-live="polite">
          Locked
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Related",
  props: {
    related: {
      type: Array,
      required: true
    }
  },
  data() {
    return {
      snackBar: false
    }
  },
  computed: {
    snackBarVisibility: function () {
      return this.snackBar
    }
  },
  methods: {
    showSnackBar(isLocked) {
      if (isLocked === "") {
        setTimeout(() => this.snackBar = false, 1000)
        return this.snackBar = true
      } else {
        if (isLocked.includes("https")) window.location.href = isLocked
        else this.goTo(isLocked)
        return this.snackBar = false
      }
    },
    goTo(route) {
      this.$router.push(route);
    }
  }
}
</script>

<style lang="scss" src="../styles/related.scss" scoped/>